module.exports = __webpack_public_path__ + "img/image02_sp.0006e89d.jpg";